// @flow

import React, { memo, useCallback } from 'react'

import { useFocusable } from '@alphaott/smart-tv-spatial-navigation'
import { ReactComponent as BackIcon } from '../../../../../assets/backArrowIcon.svg'

import {
  ChannelCardTitleBox,
  ChannelCardTitle,
  ChannelCardContainer,
  LeftContainer,
} from './BackButton.styles'

type BackButtonProps = {
  id?: string,
  focusKey?: string,
  title: string,
  style?: any,
  onFocus?: Function,
  onPress: Function,
  onArrowPress?: Function,
}

const BackButtonPure = ({
  id,
  focusKey,
  title = 'Back to all lists',
  style,
  onFocus,
  onPress,
  onArrowPress,
}: BackButtonProps) => {
  const handleFocus = useCallback((event) => onFocus(event, { id }), [id, onFocus])

  const { ref, focused } = useFocusable({
    focusKey,
    onFocus: handleFocus,
    onEnterPress: onPress,
    onArrowPress,
  })

  return (
    <ChannelCardContainer ref={ref} style={style} focused={focused} onClick={onPress}>
      <LeftContainer>
        <BackIcon />
        <ChannelCardTitleBox>
          <ChannelCardTitle>{title}</ChannelCardTitle>
        </ChannelCardTitleBox>
      </LeftContainer>
    </ChannelCardContainer>
  )
}

export const BackButton = memo<BackButtonProps>(BackButtonPure)

export default BackButton
